import { Link } from 'react-router';
import type { PlaceSummary } from '../lib/types';
import { hoursText, place as town, today } from '../lib/format';
import { kindLabel } from '../lib/places';
import { useTrip } from '../state/trip';

export default function PlacePopup({ place, number }: { place: PlaceSummary; number?: number }) {
  const { has, toggle } = useTrip();
  const inTrip = has(place.id);
  return (
    <div className="flex min-w-48 flex-col gap-1">
      <strong className="text-base">
        {number ? `${number}. ` : ''}
        {place.name}
      </strong>
      <span className="text-muted">{[kindLabel(place.kind), town(place)].filter(Boolean).join(' · ')}</span>
      <span>{hoursText(place, today())}</span>
      {place.warning && <span className="text-warn">{place.warning}</span>}
      <div className="mt-1 flex gap-2">
        <button type="button" className={`btn btn-sm ${inTrip ? '' : 'btn-primary'}`} onClick={() => toggle(place)}>
          {inTrip ? 'Remove' : 'Add to trip'}
        </button>
        <Link to={`/stops/${place.slug}`} className="btn btn-sm no-underline">
          Details
        </Link>
      </div>
    </div>
  );
}
